import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Problem } from './components/Problem';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Offer } from './components/Offer';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-legal-900 text-slate-50 font-sans selection:bg-gold-500/30" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <StatsBar data-id="element-4" />
        <Problem data-id="element-5" />
        <Modules data-id="element-6" />
        <Bonuses data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Guarantee data-id="element-9" />
        <Offer data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}